import React from 'react';
import CustomerLedgerTab from '@/components/CustomerLedgerTab';

interface CustomerLedgerPageProps {
  token: string;
}

const CustomerLedgerPage: React.FC<CustomerLedgerPageProps> = ({ token }) => {
  return <CustomerLedgerTab token={token} />;
};

export default CustomerLedgerPage;

